import type { CreateUserInput } from '@idc-forms/schemas'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateUserMutation } from '../hooks/use-user-mutations'
import { UserForm } from './user-form'

type UserCreatePanelProps = {
  onDone?: () => void
}

/** "Nuevo usuario" dentro del side panel: el mismo UserForm que la edición. */
export function UserCreatePanel({ onDone }: UserCreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateUserMutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: CreateUserInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <UserForm
      submitLabel="Crear usuario"
      pending={createMutation.isPending}
      isCreate
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
